export default {"src":"/_next/static/media/priority_low.5d266fcd.svg","height":141,"width":132,"blurWidth":0,"blurHeight":0};